import { RDCashCrop } from '@cibo/core'
import { CropChip, NotObservedChip, useFigures } from '@cibo/ui'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DetailPanelTable } from '../DetailPanelTable'

import { useMemo } from 'react'

export const CashCropPanelTable = () => {
  const { t } = useTranslation('@cibo/landmanager/CashCropPanelTable')
  const { cropYieldPerAcre } = useFigures()
  const columns = useMemo(
    () => [
      {
        header: t('crop'),
        cellContents: (historicalYield?: RDCashCrop) => (
          <Box>
            {!!historicalYield?.result ? (
              <CropChip crop={historicalYield.result} source={historicalYield.source} />
            ) : (
              <NotObservedChip />
            )}
          </Box>
        ),
      },
      {
        header: t('yieldPerAcre'),
        cellContents: (historicalYield?: RDCashCrop) => (
          <>
            {!!historicalYield?.input?.yieldPerAcre && !!historicalYield?.result
              ? cropYieldPerAcre({
                  cropYield: historicalYield.input.yieldPerAcre,
                  crop: historicalYield.result,
                })
              : '--'}
          </>
        ),
      },
    ],
    []
  )
  return <DetailPanelTable<RDCashCrop> traitId="cashCrop" columns={columns} />
}
